import React, { useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Typography, Paper, Box, Button, Grid } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import CalculateIcon from '@mui/icons-material/Calculate';
import CameraAltIcon from '@mui/icons-material/CameraAlt';

const HomePage = ({ setPageTitle }) => {
  // AppBarのタイトルを設定
  useEffect(() => {
    setPageTitle('俺たちの麻雀');
  }, [setPageTitle]);

  return (
    <Box>
      <Typography variant="h6" color="text.secondary" paragraph>
        このアプリケーションは、AIを活用して麻雀の分析を支援するサービスです。
        <br />
        各機能を使って、麻雀スキル向上にお役立てください。
      </Typography>

      <Grid container spacing={4} sx={{ mt: 4 }}>
        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ p: 3, height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <DashboardIcon color="primary" sx={{ fontSize: 40, mr: 2 }} />
              <Typography variant="h5" component="h2">
                打牌推論機能
              </Typography>
            </Box>
            <Typography variant="body1" paragraph sx={{ flexGrow: 1 }}>
              手牌と副露を入力することで、AIが推奨する打牌候補とその評価値を表示します。何を切るか迷った際の参考にしてください。
            </Typography>
            <Button
              variant="contained"
              color="primary"
              component={RouterLink}
              to="/dahai-prediction"
              sx={{ alignSelf: 'flex-start' }}
            >
              機能を使う
            </Button>
          </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ p: 3, height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <CalculateIcon color="success" sx={{ fontSize: 40, mr: 2 }} />
              <Typography variant="h5" component="h2">
                アガリ牌計算機能
              </Typography>
            </Box>
            <Typography variant="body1" paragraph sx={{ flexGrow: 1 }}>
              手牌と副露を入力すると、テンパイしている場合にアガリ牌（待ち牌）をすべて計算して表示します。
            </Typography>
            <Button
              variant="contained"
              color="success"
              component={RouterLink}
              to="/agarihai-calculation"
              sx={{ alignSelf: 'flex-start' }}
            >
              機能を使う
            </Button>
          </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ p: 3, height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <CameraAltIcon color="secondary" sx={{ fontSize: 40, mr: 2 }} />
              <Typography variant="h5" component="h2">
                牌検出機能
              </Typography>
            </Box>
            <Typography variant="body1" paragraph sx={{ flexGrow: 1 }}>
              （開発中）スマートフォンのカメラなどで撮影した実際の牌の画像から、牌を自動で認識する機能です。
            </Typography>
            <Button
              variant="contained"
              color="secondary"
              component={RouterLink}
              to="/detection"
              sx={{ alignSelf: 'flex-start' }}
            >
              機能を見る
            </Button>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default HomePage;